var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M6.75 24.167V7.833c0-3.062 1.028-4.083 4.111-4.083h6.167l8.222 8.167v12.25c0 3.062-1.028 4.083-4.111 4.083H10.86c-3.083 0-4.111-1.02-4.111-4.083",
    style: {
      mixBlendMode: "darken"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_file__filter0_dd_2424_32827)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M7 24V8c0-3 1-4 4-4h6l8 8v12c0 3-1 4-4 4H11c-3 0-4-1-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_file__paint0_linear_2424_32827)",
    fillOpacity: 0.16,
    d: "M7 24V8c0-3 1-4 4-4h6l8 8v12c0 3-1 4-4 4H11c-3 0-4-1-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_file__paint1_linear_2424_32827)",
    fillOpacity: 0.08,
    d: "M7 24V8c0-3 1-4 4-4h6l8 8v12c0 3-1 4-4 4H11c-3 0-4-1-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_file__paint2_radial_2424_32827)",
    fillOpacity: 0.2,
    d: "M7 24V8c0-3 1-4 4-4h6l8 8v12c0 3-1 4-4 4H11c-3 0-4-1-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_file__paint3_radial_2424_32827)",
    fillOpacity: 0.4,
    d: "M7 24V8c0-3 1-4 4-4h6l8 8v12c0 3-1 4-4 4H11c-3 0-4-1-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_file__paint4_radial_2424_32827)",
    fillOpacity: 0.8,
    d: "M7 24V8c0-3 1-4 4-4h6l8 8v12c0 3-1 4-4 4H11c-3 0-4-1-4-4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M17 4s5.763 5.768 8 8h-4c-3 0-4-1-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_file__paint5_linear_2424_32827)",
    fillOpacity: 0.12,
    d: "M17 4s5.763 5.768 8 8h-4c-3 0-4-1-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.08,
    d: "M17 4s5.763 5.768 8 8h-4c-3 0-4-1-4-4z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_file__paint2_radial_2424_32827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 8.5 -7.28572 0 21.375 8.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_file__paint3_radial_2424_32827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.25003 5.12498 -5.75525 -2.52674 21.875 8.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_file__paint4_radial_2424_32827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.875 4.875 -3.25 -3.25 22.25 7.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_file__paint0_linear_2424_32827",
    x1: 16,
    x2: 16,
    y1: 4,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_file__paint1_linear_2424_32827",
    x1: 16,
    x2: 16,
    y1: 4,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_file__paint5_linear_2424_32827",
    x1: 21,
    x2: 17.875,
    y1: 7.75,
    y2: 11.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_file__filter0_dd_2424_32827",
    width: 22,
    height: 28,
    x: 5,
    y: 4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2424_32827"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2424_32827",
    result: "effect2_dropShadow_2424_32827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2424_32827",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };